
import NProgress from "nprogress";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import axiosInstance from "../../../../axiosInstance";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";
import { toast } from "react-toastify";



export const GetVisitorsHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/visitors/getVisitors`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain :getDomain(),
            user_id: params?.userId? params?.userId : getUserId(),
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Visitors Retrieved Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Unable to fetch Visitors", hasError: true, data: err?.response?.data }
        })
}

export const GetVisitorsDataHelper = async (params) => {  // Dashboard
    NProgress.start()
    return await axiosInstance(`/visitors/getVisitorsData`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            from_date: params?.from_date,
            to_date: params?.to_date,
            user_id: getUserId()
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Visitors Data Retrieved Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Unable to fetch Visitors Data", hasError: true, data: err?.response?.data }
        })
}
export const AddVisitorsHelper = async (params) => {
    return await axiosInstance(`/visitors/addVisitors`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain :getDomain(),
            user_id: params?.userId? params?.userId : getUserId(),
            visitors_name: params?.name,
            visitors_mobile_no: params?.contactno,
            visited_employee_email: params?.employee_id?.office_email,
            visitor_reason_fk: params?.visitors_management_reasons_pk?.visitors_management_reasons_pk,
            visitor_image_url: params?.visitor_image_url,
            visitor_image_descriptor: params?.visitor_image_descriptor,
            visitor_reason_comment: params?.visitor_reason_comment || "",
            image_url: params?.image_url,
            checkin_timestamp: params?.checkin_timestamp,
            region_fk: params?.region_fk,
            id_proof: params?.id_proof || "",
            vehicle_no: params?.vehicle_no || "",
            multiple_org_configuration_fk: params?.multiple_org_configuration_fk?.multiple_org_configuration_pk || null,
            visitor_type: params?.visitor_type,
            token_id: params?.token_id // In - Out qr Token

        }
    })
        .then(res => {

            return { message: "Visitor Added Successfully", hasError: false, data: res?.data }
        }).catch(err => {

            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetVisitorReasonsHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/visitors/getVisitorReason`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain : getDomain(),
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Visitor Reasons Retrieved Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Unable to fetch Visitor Reasons", hasError: true, data: err?.response?.data }
        })
}

export const UpdateVisitorsHelper = async (params) => {
    return await axiosInstance(`/visitors/updateVisitors`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain :getDomain(),
            user_id: params?.userId? params?.userId : getUserId(),
            visitors_management_pk: params?.visitors_management_pk,
            checkout_timestamp: params?.checkout_timestamp,
            region_fk: params?.region_fk

        }
    })
        .then(res => {
            return { message: "Visitor Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
export const UpdateBulkVisitorsHelper = async (params) => {
    toast.info("Saving...");
    return await axiosInstance(`/visitors/updateBulkVisitors`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain :getDomain(),
            user_id: params?.userId? params?.userId : getUserId(),
            visitors_management_pk: params?.visitors_management_pk,
            checkout_timestamp: params?.checkout_timestamp,
        }
    })
        .then(res => {
            toast.dismiss();
            toast.success("Visitors Updated Successfully");
            return { message: "Visitors Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}